import { useDispatch } from 'react-redux';
import { RouteParams, useRouteParams } from './useRouteParams';
import { useIsWorkflow } from '../state/selectors';
import { setStateParams } from '../state/actions';

export const useNavigate = () => {
  const routeParams = useRouteParams();

  const isInWorkflow = useIsWorkflow();

  const dispatch = useDispatch();

  /**
   * When we are inside the comprehensive workflow, we cannot use the URL to keep
   * the context (clientId, path and provider type). In that case, we need
   * to use the Redux store.
   */
  if (isInWorkflow) {
    return (params: Partial<RouteParams>) => {
      dispatch(setStateParams({ stateParams: { ...routeParams, ...params } }));
    };
  }

  return (params: Partial<RouteParams>) => {
    ADV.util.Router.go2('DocumentVault', { ...routeParams, ...params });
  };
};
